import { render, staticRenderFns } from "./main.vue?vue&type=template&id=d129acd6&scoped=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"
import style0 from "./main.vue?vue&type=style&index=0&id=d129acd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d129acd6",
  null
  
)

export default component.exports